module.exports = __webpack_public_path__ + "img/dsci0001.4122f72a.jpg";